import { render, staticRenderFns } from "./FavoritesPage.vue?vue&type=template&id=4ba7b47d&scoped=true"
import script from "./FavoritesPage.vue?vue&type=script&lang=js"
export * from "./FavoritesPage.vue?vue&type=script&lang=js"
import style0 from "./FavoritesPage.vue?vue&type=style&index=0&id=4ba7b47d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba7b47d",
  null
  
)

export default component.exports